import request from "../../utils/fetch";
export const createSubscription = (postData) => request.post(`subscription/plans`, postData);
export const getAllSubscription = () => request.get(`subscription/plans?sort=-lastModified`);
export const getAllFeatures = () => request.get(`subscription/features`);
export const getAllSubFeatures = () => request.get(`subscription/sub-features`);
export const getAllCompanies = () => request.get("subscription/companies?isActive=true");
// delete
export const deletePlan = (id) => request.del(`subscription/plans/${id}`);
// edit
export const editPlan = (id) => request.get(`subscription/plans/${id}`);
// update
export const updatePlan = ({ postData }) => request.patch(`subscription/plans/${postData.planId}`, postData);
// update visibilty status
export const updateVisibilityStatus = (id) => request.put(`subscription/plans/${id}`);
